import Dexie from 'dexie'
import axios from 'axios'
import localforage from 'localforage'

export const urlBackend = 'https://calculadora-inrebic-api-uat.smartbits-es.com/api/login/'
export const urlCTM = 'https://ctm-spain.proyectocelvision.net'

export const auth = {
    compruebaAccesos: async function () {
        let credencialesFlag = false
        await Dexie.exists('credenciales').then(async function (exists) {
            if (exists) {
                const dbCredenciales = new Dexie('credenciales')
                await dbCredenciales.version(1).stores(
                    { credenciales: `id,nombre,mail,telefono,idToken,rol` }
                )
                const result = await dbCredenciales.credenciales.where('id').equals(1).toArray()
                if (result.length) {
                    credencialesFlag = true
                } else {
                    credencialesFlag = false
                }
            } else {
                credencialesFlag = false
            }
        })
        return credencialesFlag
    },
    destroyAccessos: async function () {
        await Dexie.delete('credenciales')
        return true
    },
    accesoAdm: async function () {
        let credencialesADMFlag = false
        await Dexie.exists('credenciales').then(async function (exists) {
            if (exists) {
                const dbCredenciales = new Dexie('credenciales')
                await dbCredenciales.version(1).stores(
                    { credenciales: `id,nombre,mail,telefono,idToken,rol` }
                )
                const result = await dbCredenciales.credenciales.where('id').equals(1).toArray()
                if (result.length) {
                    if (parseInt(result[0].rol) === parseInt(20) || parseInt(result[0].rol) === parseInt(10)) {
                        credencialesADMFlag = true
                    } else {
                        credencialesADMFlag = false
                    }
                } else {
                    credencialesADMFlag = false
                }
            } else {
                credencialesADMFlag = false
            }
        })
        return credencialesADMFlag
    }
}

export const deleteDatabases = {

    deleteAllTables: function () {
        window.sessionStorage.setItem('Bloqueado', true)
        Dexie.delete('tipoPrecio')
        Dexie.delete('costesFarmacos')
        Dexie.delete('aprovechamientoViales')
        Dexie.delete('aprovechamientoVialesDecitabina')
        Dexie.delete('rangosAprovechamientosViales')
        Dexie.delete('rangosAprovechamientosVialesDecitabina')
        Dexie.delete('dosisRangosAprovechamientosViales')
        Dexie.delete('configReblozyl')
        Dexie.delete('configFedratinib')
        Dexie.delete('configRuxolitinib')
        Dexie.delete('configTransfusion')
        Dexie.delete('configAgentesEstimuladores')
        Dexie.delete('configLenalidomina')
        Dexie.delete('configAzacitidina')
        Dexie.delete('configDecitabina')
        Dexie.delete('calculoAzacitadina')
        Dexie.delete('calculoAgenteQuelante')
        Dexie.delete('calculoLenalidomida')
        Dexie.delete('CalcuDatabase')
        Dexie.delete('calculoDecitabina')
        Dexie.delete('calculoAgenteEstimulador')
        Dexie.delete('calculoReblozyl')
        Dexie.delete('costesFarmacosThalasemia')
        Dexie.delete('costesFarmacosSMD')
        Dexie.delete('calculoTransfusion')
        Dexie.delete('rengosAprovechamientosViales')
        Dexie.delete('rengosAprovechamientosViales')

        localforage.removeItem('tipoPrecio')
        localforage.removeItem('costesFarmacos')
        localforage.removeItem('aprovechamientoViales')
        localforage.removeItem('aprovechamientoVialesDecitabina')
        localforage.removeItem('rangosAprovechamientosViales')
        localforage.removeItem('rangosAprovechamientosVialesDecitabina')
        localforage.removeItem('dosisRangosAprovechamientosViales')
        localforage.removeItem('configReblozyl')
        localforage.removeItem('configFedratinib')
        localforage.removeItem('configRuxolitinib')
        localforage.removeItem('configTransfusion')
        localforage.removeItem('configAgentesEstimuladores')
        localforage.removeItem('configLenalidomina')
        localforage.removeItem('configAzacitidina')
        localforage.removeItem('configDecitabina')
        localforage.removeItem('calculoAzacitadina')
        localforage.removeItem('calculoAgenteQuelante')
        localforage.removeItem('calculoLenalidomida')
        localforage.removeItem('CalcuDatabase')
        localforage.removeItem('calculoDecitabina')
        localforage.removeItem('calculoAgenteEstimulador')
        localforage.removeItem('calculoReblozyl')
        localforage.removeItem('costesFarmacosThalasemia')
        localforage.removeItem('costesFarmacosSMD')
        localforage.removeItem('calculoTransfusion')
        localforage.removeItem('rengosAprovechamientosViales')
        localforage.removeItem('rengosAprovechamientosViales')

    }
}

export const valoresCostes = {
    getValores: async function () {
        return await axios.post(urlBackend, {
            action: 'getdatos'
        })
    }
}

export const guardarDatos = {
    guardarDatos: async function (valores) {
        return await axios.post(urlBackend, {
            action: 'guardardatos',
            data: valores
        })
    }
}

export const valoresTalasemia = {
    caracteristicasPoblacion: {
        pesoPromedio: 55,
        superficieCorporal: 1.70
    },
    tipoPaciente: [
        {
            key: "naive",
            text: "Naïve",
            value: "naive"
        },
        {
            key: "post",
            text: "Post-ruxo",
            value: "post"
        }
    ],
    duraicionTatamiento: 12,
    duraicionTatamientoPost: 12,
    dosisFedratinib: {
        naive: {
            key: "400",
            text: "400 mg/día",
            value: 400
        },
        post: {
            key: "400",
            text: "400 mg/día",
            value: 400
        }
    },
    aprovechamientoVialesDecitabina: [
        {
            key: "conAprovechamiento",
            text: "Con aprovechamiento",
            value: 1
        },
        {
            key: "sinAprovechamiento",
            text: "Sin aprovechamiento",
            value: 2
        },
    ],
    costesFarmacilogicos: [
        {
            key: "pvlFinanciado",
            text: "PVL financiado",
            value: 1
        },
        {
            key: "pvlFinanciadoIva",
            text: "PVL financiado + IVA",
            value: 2
        },
        {
            key: "pvlFinanciadoDeduccion",
            text: "PVL financiado - Deducción RD 08/2010",
            value: 3
        },
        {
            key: "pvlFinanciadoIvaDeduccion",
            text: "PVL financiado + IVA - Deducción RD 08/2010",
            value: 4
        },
        {
            key: "pvlNotificado",
            text: "PVL notificado",
            value: 5
        },
        {
            key: "pvlNotificadooIva",
            text: "PVL notificado + IVA",
            value: 6
        },
        {
            key: "pvlNotificadoDeduccion",
            text: "PVL notificado - Deducción RD 08/2010",
            value: 7
        },
        {
            key: "pvlNotificadoIvaDeduccion",
            text: "PVL notificado + IVA - Deducción RD 08/2010",
            value: 8
        }
    ],
    referencias: [
        "Agencia Europea de Medicamentos. Ficha técnica de Inrebic 100 mg cápsulas duras. [citado 15 feb 2023]. Disponible en: https://www.ema.europa.eu/en/documents/product-information/inrebic-epar-product-information_es.pdf",
        "Agencia Europea de Medicamentos. Ficha técnica de Jakavi 5 mg comprimidos,  Jakavi 10 mg comprimidos,  Jakavi 15 mg comprimidos,  Jakavi 20 mg comprimidos. [citado 15 feb 2023]. Disponible en: https://www.ema.europa.eu/en/documents/product-information/jakavi-epar-product-information_es.pdf",
        "Consejo General de Colegios Oficiales de Farmacéuticos. Base de datos del Conocimiento Sanitario - Bot Plus 2.0 [Internet]. Madrid: Consejo General de Colegios Oficiales de Farmacéuticos; 2023 [citado 15 feb 2023]. Disponible en: https://botplusweb.portalfarma.com/",
        "Boletín Oficial del Estado (BOE). Ley 37/1992, de 28 de dicembre, del Impuesto sobre el Valor Añadido. [citado 15 feb 2023]. Disponible en: https://www.boe.es/buscar/pdf/1992/BOE-A-1992-28740-consolidado.pdf",
        "Boletín Oficial del Estado (BOE). Real decreo-ley 8/2010, de 20 de mayo, por el que se adoptan medidas extraordinarias para la reducción del déficit público. [citado 15 feb 2023]. Disponible en: https://www.boe.es/buscar/pdf/2010/BOE-A-2010-8228-consolidado.pdf"
    ]
};

export const costesFarmacosTalasemia_default = [
    {
        "id": 1,
        "Principio activo": "Fedratinib",
        "Presentación": "120 cápsulas de 100 mg",
        "mg": 100,
        "dosis": 400,
        "Unidades": 120,
        "PVL notificado": 4765.63,
        "PVL financiado": 2171.07,
        "Deducción RD": 4,
        "IVA": 4,
        "ambos": 1
    },
    {
        "id": 2,
        "Principio activo": "Ruxolitinib",
        "Presentación": "56 cápsulas de 10 mg",
        "mg": 10,
        "dosis": 20,
        "Unidades": 56,
        "PVL notificado": 3583.33,
        "PVL financiado": 1868.11,
        "Deducción RD": 7.5,
        "IVA": 4,
        "ambos": 0,
        "tipo": "Post-ruxo"
    },
    {
        "id": 3,
        "Principio activo": "Ruxolitinib",
        "Presentación": "56 cápsulas de 20 mg",
        "mg": 20,
        "dosis": 40,
        "Unidades": 56,
        "PVL notificado": 3583.33,
        "PVL financiado": 2802.16,
        "Deducción RD": 7.5,
        "IVA": 4,
        "ambos": 0,
        "tipo": "Naïve"
    }
]

export const configAlternativas = {
    createConfigAlterniativas: async function (calc) {
        localforage.getItem('configFedratinib', async function (err, value) {
            if (!value) {
                await localforage.setItem('configFedratinib', {
                    id: 1,
                    dosis: 400,
                    dosisPost: 400,
                    descuento: 0,
                    checked: true
                })
            }
        });
        localforage.getItem('configRuxolitinib', async function (err, value) {
            if (!value) {
                await localforage.setItem('configRuxolitinib', {
                    id: 1,
                    dosis: 40,
                    dosisPost: 20,
                    descuento: 0,
                    checked: false
                })
            }
        });
    },
    getValores: async function (alternativa) {
        return await localforage.getItem(alternativa, function (err, value) {
            return value
        });
    }
}

export const costesFarmacosTalasemia = {
    getValores: async function () {
        return await localforage.getItem('costesFarmacosThalasemia', function (err, value) {
            return value
        });
    },
}

export const calculosTalasemia = {
    getValores: async function () {
        return await localforage.getItem('calculosThalasemia', function (err, value) {
            return value
        });
    },
}

export const resultadosTalasemia = {
    getValores: async function () {
        return await localforage.getItem('resultadosThalasemia', function (err, value) {
            return value
        });
    },
}

export const crearTipoPrecio = {
    createTipoPrecio: async function (tipoPrecio) {
        await localforage.setItem('tipoPrecio', tipoPrecio)
    }
}

export const calcular = {
    costesFarmacos: async function (calculadora, descuentoAplicado, tipoPrecio) {
        if (tipoPrecio) {
            Dexie.delete('tipoPrecio');
            const db = new Dexie('tipoPrecio')
            await db.version(1).stores(
                { tipoPrecio: `id,value` }
            )
            db.tipoPrecio.put({
                id: 1,
                value: tipoPrecio
            });
            localforage.setItem('tipoPrecio', tipoPrecio)
        }

        let costes = await costesFarmacosTalasemia.getValores();
        const rows = [
            'Principio activo',
            'Presentación',
            'mg/Unidad',
            'Unidades',
            'IVA',
            'Reducción RD',
            'PVL notificado',
            'PVL notificado/unidad',
            'PVL notificado/unidad + IVA',
            'PVL notificado/unidad - Reducción RD',
            'PVL notificado/unidad + IVA - Reducción RD',
            'PVL financiado',
            'PVL financiado/unidad',
            'PVL financiado/unidad + IVA',
            'PVL financiado/unidad - Reducción RD',
            'PVL financiado/unidad + IVA - Reducción RD',
            'Establecido por usuario',
            'Establecido por usuario/unidad'
        ];
        costes.forEach(coste => {
            rows.forEach(row => {
                switch (row) {
                    case 'mg/Unidad':
                        coste[row] = (coste['mg']);
                        break;

                    case 'IVA':
                        coste[row] = (coste['IVA']);
                        break;

                    case 'Reducción RD':
                        coste[row] = (coste['Deducción RD']);
                        break;

                    case 'PVL notificado/unidad':
                        coste[row] = (coste['PVL notificado'] / coste['Unidades']);
                        break;

                    case 'PVL notificado/unidad + IVA':
                        coste[row] = ((coste['PVL notificado'] / coste['Unidades']) + ((coste['PVL notificado'] / coste['Unidades']) * (coste['IVA'] / 100)));
                        break;

                    case 'PVL notificado/unidad - Reducción RD':
                        coste[row] = ((coste['PVL notificado'] / coste['Unidades']) - ((coste['PVL notificado'] / coste['Unidades']) * (coste['Deducción RD'] / 100)));
                        break;

                    case 'PVL notificado/unidad + IVA - Reducción RD':
                        coste[row] = ((coste['PVL notificado'] / coste['Unidades']) + ((coste['PVL notificado'] / coste['Unidades']) * (coste['IVA'] / 100)) - ((coste['PVL notificado'] / coste['Unidades']) * (coste['Deducción RD'] / 100)));
                        break;

                    case 'PVL financiado/unidad':
                        coste[row] = (coste['PVL financiado'] / coste['Unidades']);
                        break;

                    case 'PVL financiado/unidad + IVA':
                        coste[row] = ((coste['PVL financiado'] / coste['Unidades']) + ((coste['PVL financiado'] / coste['Unidades']) * (coste['IVA'] / 100)));
                        break;

                    case 'PVL financiado/unidad - Reducción RD':
                        coste[row] = ((coste['PVL financiado'] / coste['Unidades']) - ((coste['PVL financiado'] / coste['Unidades']) * (coste['Deducción RD'] / 100)));
                        break;

                    case 'PVL financiado/unidad + IVA - Reducción RD':
                        coste[row] = ((coste['PVL financiado'] / coste['Unidades']) + ((coste['PVL financiado'] / coste['Unidades']) * (coste['IVA'] / 100)) - ((coste['PVL financiado'] / coste['Unidades']) * (coste['Deducción RD'] / 100)));
                        break;

                    default:
                        break;
                }
            })
        });

        await localforage.setItem('costesFarmacos', costes)

        this.calculosPage()
        return false
    },
    calculosPage: async function () {
        //Tipo de Precio Reducciones - Decuentos
        let tipoPrecio = {}
        await localforage.getItem('tipoPrecio', async function (err, value) {
            if (value) {
                tipoPrecio = value
            }
        });
        // console.log(tipoPrecio);

        let costesFarmacos = []
        await localforage.getItem('costesFarmacos', async function (err, value) {
            if (value) {
                costesFarmacos = value
            }
        })

        // let configFedratinib = await configAlternativas.getValores('configFedratinib');
        // let configRuxolitinib = await configAlternativas.getValores('configRuxolitinib');

        let descuentoFedratinib = 0;
        let descuentoRuxolitinib = 0;
        sessionStorage.getItem('descuentoFedratinib') != null ? descuentoFedratinib = (sessionStorage.getItem('descuentoFedratinib')) : sessionStorage.setItem('descuentoFedratinib', descuentoFedratinib);
        sessionStorage.getItem('descuentoRuxolitinib') != null ? descuentoRuxolitinib = (sessionStorage.getItem('descuentoRuxolitinib')) : sessionStorage.setItem('descuentoRuxolitinib', descuentoRuxolitinib);


        const calculos = [];

        const tipoPaciente = ['Naïve', 'Post-ruxo'];

        const rows = [
            'Fármaco',
            'Tipo Paciente',
            'Dosis Diaria',
            'mg/cápsula',
            'Cápsulas/día',
            'Cápsulas/semana',
            'Cápsulas/mes',
            'Duración del tratamiento',
            'Cápsulas totales',
            'Dosis Total',
            'Precio/Cápsula Sin Descuento',
            'Precio/Cápsula Con Descuento',
            'COSTE MES',
            'COSTE TOTAL'
        ];
        costesFarmacos.sort(function (a, b) { return a.orden < b.orden ? -1 : 1 }).forEach(coste => {
            // console.log(coste)
            if (coste['ambos'] == 1) {
                tipoPaciente.forEach((tipo, i) => {
                    let fila = {
                        'Fármaco': '',
                        'Tipo Paciente': '',
                        'Dosis Diaria': 0,
                        'mg/cápsula': 0,
                        'Cápsulas/día': 0,
                        'Cápsulas/semana': 0,
                        'Cápsulas/mes': 0,
                        'Duración del tratamiento': '',
                        'Cápsulas totales': 0,
                        'Dosis Total': 0,
                        'Precio/Cápsula Sin Descuento': 0,
                        'Precio/Cápsula Con Descuento': 0,
                        'COSTE MES': 0,
                        'COSTE TOTAL': 0
                    };
                    rows.forEach(row => {
                        switch (row) {
                            case 'Fármaco':
                                fila[row] = coste['Principio activo'];
                                break;
                            case 'Tipo Paciente':
                                fila[row] = tipo;
                                break;
                            case 'Dosis Diaria':
                                fila[row] = coste['dosis'];
                                break;
                            case 'mg/cápsula':
                                fila[row] = coste['mg'];
                                break;
                            case 'Cápsulas/día':
                                fila[row] = coste['dosis'] / coste['mg'];
                                break;
                            case 'Cápsulas/semana':
                                fila[row] = fila['Cápsulas/día'] * 7;
                                break;
                            case 'Cápsulas/mes':
                                fila[row] = fila['Cápsulas/día'] * 30.4;
                                break;
                            case 'Duración del tratamiento':
                                fila[row] = tipo === 'Naïve' ? parseInt(window.sessionStorage.getItem("duracionTratamiento")) : parseInt(window.sessionStorage.getItem("duracionTratamientoPost"));
                                break;
                            case 'Cápsulas totales':
                                fila[row] = fila['Cápsulas/mes'] * fila['Duración del tratamiento'];
                                break;
                            case 'Dosis Total':
                                fila[row] = fila['Cápsulas totales'] * fila['mg/cápsula'];
                                break;
                            case 'Precio/Cápsula Sin Descuento':
                                let precio = 0;
                                switch (tipoPrecio.value) {
                                    case 1:
                                        precio = coste['PVL financiado/unidad'];
                                        break;
                                    case 2:
                                        precio = coste['PVL financiado/unidad + IVA'];
                                        break;
                                    case 3:
                                        precio = coste['PVL financiado/unidad - Reducción RD'];
                                        break;
                                    case 4:
                                        precio = coste['PVL financiado/unidad + IVA - Reducción RD'];
                                        break;
                                    case 5:
                                        precio = coste['PVL notificado/unidad'];
                                        break;
                                    case 6:
                                        precio = coste['PVL notificado/unidad + IVA'];
                                        break;
                                    case 7:
                                        precio = coste['PVL notificado/unidad - Reducción RD'];
                                        break;
                                    case 8:
                                        precio = coste['PVL notificado/unidad + IVA - Reducción RD'];
                                        break;
                                    default:
                                        break;
                                }
                                fila[row] = precio;
                                break;
                            case 'Precio/Cápsula Con Descuento':
                                fila[row] = fila['Precio/Cápsula Sin Descuento'] - (fila['Precio/Cápsula Sin Descuento']*(descuentoFedratinib/100));
                                break;
                            case 'COSTE MES':
                                fila[row] = fila['Cápsulas/mes'] * fila['Precio/Cápsula Con Descuento'];
                                break;
                            case 'COSTE TOTAL':
                                fila[row] =
                                    fila[row] = fila['Cápsulas totales'] * fila['Precio/Cápsula Con Descuento'];
                                break;
                            default:
                                break;
                        }
                    })
                    calculos.push(fila);
                })
            } else {
                tipoPaciente.filter(tipo => tipo == coste['tipo']).forEach((tipo, i) => {
                    let fila = {
                        'Fármaco': '',
                        'Tipo Paciente': '',
                        'Dosis Diaria': 0,
                        'mg/cápsula': 0,
                        'Cápsulas/día': 0,
                        'Cápsulas/semana': 0,
                        'Cápsulas/mes': 0,
                        'Duración del tratamiento': '',
                        'Cápsulas totales': 0,
                        'Dosis Total': 0,
                        'Precio/Cápsula Sin Descuento': 0,
                        'Precio/Cápsula Con Descuento': 0,
                        'COSTE MES': 0,
                        'COSTE TOTAL': 0
                    };
                    rows.forEach(row => {
                        switch (row) {
                            case 'Fármaco':
                                fila[row] = coste['Principio activo'];
                                break;
                            case 'Tipo Paciente':
                                fila[row] = tipo;
                                break;
                            case 'Dosis Diaria':
                                fila[row] = coste['dosis'];
                                break;
                            case 'mg/cápsula':
                                fila[row] = coste['mg'];
                                break;
                            case 'Cápsulas/día':
                                fila[row] = coste['dosis'] / coste['mg'];
                                break;
                            case 'Cápsulas/semana':
                                fila[row] = fila['Cápsulas/día'] * 7;
                                break;
                            case 'Cápsulas/mes':
                                fila[row] = fila['Cápsulas/día'] * 30.4;
                                break;
                            case 'Duración del tratamiento':
                                fila[row] = tipo === 'Naïve' ? parseInt(window.sessionStorage.getItem("duracionTratamiento")) : parseInt(window.sessionStorage.getItem("duracionTratamientoPost"));
                                break;
                            case 'Cápsulas totales':
                                fila[row] = fila['Cápsulas/mes'] * fila['Duración del tratamiento'];
                                break;
                            case 'Dosis Total':
                                fila[row] = fila['Cápsulas totales'] * fila['mg/cápsula'];
                                break;
                            case 'Precio/Cápsula Sin Descuento':
                                let precio = 0;
                                switch (tipoPrecio.value) {
                                    case 1:
                                        precio = coste['PVL financiado/unidad'];
                                        break;
                                    case 2:
                                        precio = coste['PVL financiado/unidad + IVA'];
                                        break;
                                    case 3:
                                        precio = coste['PVL financiado/unidad - Reducción RD'];
                                        break;
                                    case 4:
                                        precio = coste['PVL financiado/unidad + IVA - Reducción RD'];
                                        break;
                                    case 5:
                                        precio = coste['PVL notificado/unidad'];
                                        break;
                                    case 6:
                                        precio = coste['PVL notificado/unidad + IVA'];
                                        break;
                                    case 7:
                                        precio = coste['PVL notificado/unidad - Reducción RD'];
                                        break;
                                    case 8:
                                        precio = coste['PVL notificado/unidad + IVA - Reducción RD'];
                                        break;
                                    default:
                                        break;
                                }
                                fila[row] = precio;
                                break;
                            case 'Precio/Cápsula Con Descuento':
                                fila[row] = fila['Precio/Cápsula Sin Descuento'] - (fila['Precio/Cápsula Sin Descuento']*(descuentoRuxolitinib/100));
                                break;
                            case 'COSTE MES':
                                fila[row] = fila['Cápsulas/mes'] * fila['Precio/Cápsula Con Descuento'];
                                break;
                            case 'COSTE TOTAL':
                                fila[row] =
                                    fila[row] = fila['Cápsulas totales'] * fila['Precio/Cápsula Con Descuento'];
                                break;
                            default:
                                break;
                        }
                    })
                    calculos.push(fila);
                })
            }

        })

        await localforage.setItem('calculosThalasemia', calculos);

        this.resultados()
        return false
    },
    resultados: async function () {
        let costesFarmacos = []
        await localforage.getItem('costesFarmacos', async function (err, value) {
            if (value) {
                costesFarmacos = value
            }
        })

        let calculos = []
        await localforage.getItem('calculosThalasemia', async function (err, value) {
            if (value) {
                calculos = value
            }
        })
        let resultados = {};
        await localforage.getItem('resultadosThalasemia', async function (err, value) {
            if (value) {
                resultados = value
            }
        })
        console.log(resultados)
        let muestraNaiveFedratinib = 1;
        let muestraNaiveRuxolitinib = 1;
        let muestraPostFedratinib = 1;
        let muestraPostRuxolitinib = 1;
        sessionStorage.getItem('muestraNaiveFedratinib') != null ? muestraNaiveFedratinib = parseInt(sessionStorage.getItem('muestraNaiveFedratinib')) : sessionStorage.setItem('muestraNaiveFedratinib', muestraNaiveFedratinib);

        sessionStorage.getItem('muestraNaiveRuxolitinib') != null ? muestraNaiveRuxolitinib = parseInt(sessionStorage.getItem('muestraNaiveRuxolitinib')) : sessionStorage.setItem('muestraNaiveRuxolitinib', muestraNaiveRuxolitinib);
        console.log(sessionStorage.getItem('muestraPostFedratinib'))
        sessionStorage.getItem('muestraPostFedratinib') != null ? muestraPostFedratinib = parseInt(sessionStorage.getItem('muestraPostFedratinib')) : sessionStorage.setItem('muestraPostFedratinib', muestraPostFedratinib);

        sessionStorage.getItem('muestraPostRuxolitinib') != null ? muestraPostRuxolitinib = parseInt(sessionStorage.getItem('muestraPostRuxolitinib')) : sessionStorage.setItem('muestraPostRuxolitinib', muestraPostRuxolitinib);

        const tipoPaciente = ['Naïve', 'Post-ruxo'];
        const tipoCoste = ['Paciente', 'Poblacion'];

        const rowsPaciente = [
            'Fármaco',
            'Coste mensual',
            'Coste del tratamiento',
            'Coste incremental'
        ];
        const rowsPoblacion = [
            'Fármaco',
            'Tamaño de la muestra',
            'Coste poblacional',
            'Coste incremental'
        ];
        if (Object.keys(resultados).length === 0) {
            resultados = { 'Naïve': {}, 'Post-ruxo': {} }
            tipoPaciente.forEach(tipoPa => {
                resultados[tipoPa] = { 'Paciente': {}, 'Poblacion': {} }
                tipoCoste.forEach(tipoCo => {
                    resultados[tipoPa][tipoCo] = {};
                    //datos[tipoPa][tipoCo] = tipoCo == 'Paciente' ? {'Fármaco':'','Coste mensual':0,'Coste del tratamiento':0,'Coste incremental':0} : {'Fármaco':'','Tamaño de la muestra':1,'Coste poblacional':0,'Coste incremental':0};
                    calculos.filter(coste => coste['Tipo Paciente'] == tipoPa).forEach(coste => {
                        resultados[tipoPa][tipoCo][coste['Fármaco']] = tipoCo == 'Paciente' ? { 'Fármaco': '', 'Coste mensual': 0, 'Coste del tratamiento': 0, 'Coste incremental': 0 } : { 'Fármaco': '', 'Tamaño de la muestra': 1, 'Coste poblacional': 0, 'Coste incremental': 0 };
                        if (tipoCo == 'Paciente') {
                            rowsPaciente.forEach(row => {
                                switch (row) {
                                    case 'Fármaco':
                                        resultados[tipoPa][tipoCo][coste['Fármaco']]['Fármaco'] = coste['Fármaco'];
                                        break;
                                    case 'Coste mensual':
                                        resultados[tipoPa][tipoCo][coste['Fármaco']]['Coste mensual'] = coste['COSTE MES'];
                                        break;
                                    case 'Coste del tratamiento':
                                        resultados[tipoPa][tipoCo][coste['Fármaco']]['Coste del tratamiento'] = coste['COSTE TOTAL'];
                                        break;
                                    case 'Coste incremental':
                                        resultados[tipoPa][tipoCo][coste['Fármaco']]['Coste incremental'] = coste['Fármaco'] == 'Fedratinib' ? 0 : resultados[tipoPa][tipoCo]['Fedratinib']['Coste del tratamiento'] - resultados[tipoPa][tipoCo][coste['Fármaco']]['Coste del tratamiento'];
                                        break;
                                    default:
                                        break;
                                }
                            })
                        } else {
                            rowsPoblacion.forEach(row => {
                                switch (row) {
                                    case 'Fármaco':
                                        resultados[tipoPa][tipoCo][coste['Fármaco']]['Fármaco'] = coste['Fármaco'];
                                        break;
                                    case 'Coste poblacional':
                                        resultados[tipoPa][tipoCo][coste['Fármaco']]['Coste poblacional'] = (tipoPa == 'Naïve' ? (coste['Fármaco'] == 'Fedratinib' ? muestraNaiveFedratinib : muestraNaiveRuxolitinib) : (coste['Fármaco'] == 'Fedratinib' ? muestraPostFedratinib : muestraPostRuxolitinib)) * coste['COSTE TOTAL'];
                                        break;
                                    case 'Tamaño de la muestra':
                                        resultados[tipoPa][tipoCo][coste['Fármaco']]['Tamaño de la muestra'] = (tipoPa == 'Naïve' ? (coste['Fármaco'] == 'Fedratinib' ? muestraNaiveFedratinib : muestraNaiveRuxolitinib) : (coste['Fármaco'] == 'Fedratinib' ? muestraPostFedratinib : muestraPostRuxolitinib));
                                        break;
                                    case 'Coste incremental':
                                        resultados[tipoPa][tipoCo][coste['Fármaco']]['Coste incremental'] = coste['Fármaco'] == 'Fedratinib' ? 0 : resultados[tipoPa][tipoCo]['Fedratinib']['Coste poblacional'] - resultados[tipoPa][tipoCo][coste['Fármaco']]['Coste poblacional']
                                        break;
                                    default:
                                        break;
                                }
                            })
                        }
                    })
                })
            })
        } else {
            tipoPaciente.forEach(tipoPa => {
                tipoCoste.forEach(tipoCo => {
                    //datos[tipoPa][tipoCo] = tipoCo == 'Paciente' ? {'Fármaco':'','Coste mensual':0,'Coste del tratamiento':0,'Coste incremental':0} : {'Fármaco':'','Tamaño de la muestra':1,'Coste poblacional':0,'Coste incremental':0};
                    calculos.filter(coste => coste['Tipo Paciente'] == tipoPa).forEach(coste => {
                        if (tipoCo == 'Paciente') {
                            rowsPaciente.forEach(row => {
                                switch (row) {
                                    case 'Fármaco':
                                        resultados[tipoPa][tipoCo][coste['Fármaco']]['Fármaco'] = coste['Fármaco'];
                                        break;
                                    case 'Coste mensual':
                                        resultados[tipoPa][tipoCo][coste['Fármaco']]['Coste mensual'] = coste['COSTE MES'];
                                        break;
                                    case 'Coste del tratamiento':
                                        resultados[tipoPa][tipoCo][coste['Fármaco']]['Coste del tratamiento'] = coste['COSTE TOTAL'];
                                        break;
                                    case 'Coste incremental':
                                        resultados[tipoPa][tipoCo][coste['Fármaco']]['Coste incremental'] = coste['Fármaco'] == 'Fedratinib' ? 0 : resultados[tipoPa][tipoCo]['Fedratinib']['Coste del tratamiento'] - resultados[tipoPa][tipoCo][coste['Fármaco']]['Coste del tratamiento'];
                                        break;
                                    default:
                                        break;
                                }
                            })
                        } else {
                            rowsPoblacion.forEach(row => {
                                switch (row) {
                                    case 'Fármaco':
                                        resultados[tipoPa][tipoCo][coste['Fármaco']]['Fármaco'] = coste['Fármaco'];
                                        break;
                                    case 'Coste poblacional':
                                        resultados[tipoPa][tipoCo][coste['Fármaco']]['Coste poblacional'] = resultados[tipoPa][tipoCo][coste['Fármaco']]['Tamaño de la muestra'] * coste['COSTE TOTAL'];
                                        break;
                                    case 'Tamaño de la muestra':
                                        resultados[tipoPa][tipoCo][coste['Fármaco']]['Tamaño de la muestra'] = (tipoPa == 'Naïve' ? (coste['Fármaco'] == 'Fedratinib' ? muestraNaiveFedratinib : muestraNaiveRuxolitinib) : (coste['Fármaco'] == 'Fedratinib' ? muestraPostFedratinib : muestraPostRuxolitinib));
                                        break;
                                    case 'Coste incremental':
                                        resultados[tipoPa][tipoCo][coste['Fármaco']]['Coste incremental'] = coste['Fármaco'] == 'Fedratinib' ? 0 : resultados[tipoPa][tipoCo]['Fedratinib']['Coste poblacional'] - resultados[tipoPa][tipoCo][coste['Fármaco']]['Coste poblacional']
                                        break;
                                    default:
                                        break;
                                }
                            })
                        }
                    })
                })
            })
        }
        // console.log(datos)

        await localforage.setItem('resultadosThalasemia', resultados);

        return false
    }
}